import { render } from "./LinkDetail.vue?vue&type=template&id=33af9741"
import script from "./LinkDetail.vue?vue&type=script&lang=js"
export * from "./LinkDetail.vue?vue&type=script&lang=js"

import "./LinkDetail.vue?vue&type=style&index=0&id=33af9741&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__